<template>
  <div>
    <div class="title-div">{{title}}</div>
    <div class="form-div">
      <el-form :model="form" :rules="rules" hide-required-asterisk label-position="top" label-width="80px" ref="form">
        <el-form-item label="报修人姓名：" prop="name">
          <el-input :disabled="true" maxlength="11" placeholder="请输入" v-model="form.repairApplicantName"></el-input>
        </el-form-item>
        <el-form-item label="报修人电话：" prop="telephone">
          <el-input :disabled="true" maxlength="11" placeholder="请填写联系电话" v-model="form.reportTelephone"></el-input>
        </el-form-item>
        <el-form-item label="燃气用户编号：" prop="userNumber">
          <el-input :disabled="true" maxlength="11" placeholder="请输入燃气用户编号" v-model="form.userNumber"></el-input>
        </el-form-item>
        <!--<el-form-item label="燃气用户编号：" prop="userNumber">
          <el-select maxlength="11" placeholder="请选择" v-model="form.userNumber"  style="width: 100%">
            <el-option
              :key="item.userCode"
              :label="item.userCode"
              :value="item.userCode"
              v-for="item in userNumberColumns">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="地址：" prop="repairAddress">
          <el-input :disabled="true" type="textarea" autosize placeholder="" v-model="form.repairAddress"></el-input>
        </el-form-item>
        <el-form-item label="报修类型：" prop="formTypeValue">
          <el-select maxlength="11" placeholder="请选择" v-model="form.formTypeValue" style="width: 100%">
            <el-option
              :key="item.value"
              :label="item.meaning"
              :value="item.value"
              v-for="item in formTypeColumns">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：" prop="remarks">
          <el-input autosize
                    placeholder="请详细描述维修对象、损坏情况等；如联系人不是报修人，请填写联系人和电话"
                    type="textarea"
                    v-model="form.remarks">

          </el-input>
        </el-form-item>
        <el-form-item label="添加图片：" prop="addPic">
          <el-upload
            :file-list="uploader"
            :class="{hide:hideUpload}"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-change="handleChange"
            :auto-upload="false"
            limit="2"
            action="#"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img :src="dialogImageUrl" alt="" width="100%">
          </el-dialog>
        </el-form-item>
        <el-form-item>
          <el-button @click="onSubmit" class="submit-button" type="primary" :loading="loading">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getUserGasList } from '../../../api/accountNumberManagement'
  import { codeValueList, addrepairs } from '../../../api/repair'

  export default {
    name: 'PCRepair',
    data () {
      //备注验证
      var validatorRemarks = function (rule, value, callback) {
        let rules = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
        if (value && value.indexOf('|') > -1) {
          callback(new Error('备注中不能包含“|”符号'))
        } else {
          callback()
        }
      }
      return {

        hideUpload: false,//
        loading:false,  //提交按鈕loading
        showUserNumberPicker: false, // 是否展示燃气用户编号选择器
        userNumberColumns: [], // 燃气用户编号列表
        showFormTypePicker: false, // 是否展示报修类型选择器
        formTypeColumns: [], // 报修类型列表
        uploader: [], // 报修图片
        title: '', // 页面标题
        typeMap: [
          {
            label: '管道阀门报修',
            value: 'BG_GAS_PIPE'
          },
          {
            label: '燃气表报修',
            value: 'BG_GAS_METER'
          },
          {
            label: '燃气具报修',
            value: 'BG_GAS_STOVE'
          },
          {
            label: '其他报修',
            value: 'BG_GAS_OTHER'
          },
          {
            label: '燃气预约巡检',
            value: 'BG_GAS_INSPECTSUB'
          },
          {
            label: '燃气拆改',
            value: 'BG_GAS_MODIFY'
          },
        ], // 报修类型
        repairType: '', // 报修类型
        repairTypeChina: '', // 报修类型中文
        meterType: false,
        meterTypeChina: '', // 卡表厂家
        meterTypes: [
          '泰科',
          '思凯',
          '天庆',
          '其他'
        ], // 卡表厂家列表
        cardChar: 'C', // 卡表的标志
        appContactId: '',
        userId: '',
        form: {
          userNumber: '', // 燃气用户编号
          repairApplicantName: '', // 报修人姓名
          reportTelephone: '', // 报修人电话
          repairAddress: '', // 地址
          formType: '', // 报修类型
          formTypeValue: '', // 报修类型值
          remarks: '', // 备注
        },
        dialogVisible: false,
        dialogImageUrl: '',
        gasAccountInfo: {}, // 户号信息
        rules: {
          userNumber: [
            {
              required: true,
              message: '请选择您的用户编号',
              trigger: 'change'
            }
          ],
          repairAddress: [
            {
              required: true,
              message: '',
              trigger: 'blur'
            }
          ],
          formTypeValue: [
            {
              required: true,
              message: '请选择表单类型',
              trigger: 'change'
            }
          ],
          remarks: [
            {
              required: true,
              message: '请输入备注',
              trigger: 'blur'
            },
            { required: true, validator: validatorRemarks, trigger: 'blur' },
          ],

        } // 校验规则
      }
    },

    mounted () {
      if (this.$route.params.title == '管道阀门' || this.$route.params.title == '燃气表' || this.$route.params.title == '燃气具') {
        this.title = this.$route.params.title + '报修'
        this.repairTypeChina = this.$route.params.title + '报修'

      } else {
        this.title = this.$route.params.title
        this.repairTypeChina = this.$route.params.title
      }
      this.gasAccountInfo = this.$route.params.gasAccountInfo
      this.form.userNumber = this.$route.params.gasAccountInfo.gasAccount
      this.form.repairAddress = this.$route.params.gasAccountInfo.address
      this.meterType = (this.$route.params.gasAccountInfo.meterType == this.cardChar)
      this.form.repairApplicantName = JSON.parse(window.localStorage.userInfo).contacts
      this.appContactId = JSON.parse(window.localStorage.userInfo).appContactId
      this.userId = JSON.parse(window.localStorage.userInfo).id
      this.form.reportTelephone = JSON.parse(window.localStorage.userInfo).mobile
      // this.getNumberList()
      this.getRepairType()
    },
    computed:{

    },
    /*watch:{
      //监听户号变化，改变维修地址
      form: {
        handler(newValue, oldValue) {
          for (let i = 0; i <this.userNumberColumns.length ; i++) {
            if (this.userNumberColumns[i].userCode ==  newValue.userNumber) {
              this.form.repairAddress = this.userNumberColumns[i].address
            }
          }
        },
        deep: true
      },
    },*/

    methods: {
      // 获取用户绑定的燃气号列表
      getNumberList () {
        const that = this
        const params = {
          userId: window.localStorage.userId
        }
        getUserGasList(params).then(res => {
          if (res.data.success) {
            if (res.data.rows.length > 0) {
              that.userNumberColumns = []
              for (let i = 0; i < res.data.rows.length; i++) {
                that.userNumberColumns.push(res.data.rows[i])
              }
              that.form.userNumber = that.userNumberColumns[0].userCode
              that.form.repairAddress = that.userNumberColumns[0].address
              that.meterType = (that.userNumberColumns[0].meterType == that.cardChar)
            } else {
              that.userNumber = '没有户号'
            }
          } else {
            that.$message.error((res.data.message ? res.data.message : '获取用户编号异常'))
          }
        }).catch(() => {
          that.$message.error('获取用户编号异常')
        })
      },
      // 获取对应报修类型的具体报修类型信息
      getRepairType () {
        const that = this
        let params = {}
        for (let i = 0; i < that.typeMap.length; i++) {
          if (that.typeMap[i].label == that.repairTypeChina) {
            params = { code: that.typeMap[i].value }
          }
        }
        codeValueList(params).then(res => {
          if (res.data.success) {
            that.formTypeColumns = []
            for (let i = 0; i < res.data.rows.length; i++) {
              that.formTypeColumns.push(res.data.rows[i])
            }
          } else {
            that.$message.error((res.data.message ? res.data.message : '获取报修类型异常'))
          }
        }).catch(() => {
          that.$message.error('获取报修类型异常')
        })
      },

      //提交
      onSubmit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const that = this
            that.loading = true
            let userNote_ = that.form.remarks.split('\n').join('，')
            userNote_ = userNote_ + ((that.meterType && that.meterTypeChina) ? ('（卡表厂家：' + that.meterTypeChina + '）') : '')
            const formData = new FormData()
            formData.append('userNote', userNote_)

            for (let i = 0; i < that.formTypeColumns.length; i++) {
              if (that.formTypeColumns[i].value == that.form.formTypeValue) {
                that.form.formType = that.formTypeColumns[i].meaning
              }
            }
            const inputModel = {
              repairName: that.form.repairApplicantName,
              repairCall: that.form.reportTelephone,
              gasUserNumber: that.form.userNumber,
              detailedAddress: that.form.repairAddress,
              repairType: that.form.formTypeValue,
              repairTypeChina: that.form.formType,
              type: that.repairTypeChina,
              appContactId: that.appContactId,
              userId: that.userId,
              dataSource: 'Bjtong'
            }
            for (const i in inputModel) {
              formData.append(i, inputModel[i])
            }
            if (that.repairTypeChina !== '燃气预约巡检' && that.uploader.length > 0) {
              for (let j = 0; j < that.uploader.length; j++) {
                  formData.append('file', that.uploader[j].raw, that.repairApplicantName + '-报修-.jpg') // 文件对象bl
                 /* if (j == (that.uploader.length - 1)) {
                    that.onBolb(formData)
                  }*/
              }
            }
            that.onBolb(formData)
          } else {
            return false
          }
        })
      },
      // 提交报修信息
      onBolb (formData) {
        const that = this
        addrepairs(formData).then(res => {
          if (res.data.success) {
            let userInfo = JSON.parse(window.localStorage.userInfo)
            userInfo.appContactId = res.data.rows[0].appContactId
            window.localStorage.userInfo = JSON.stringify(userInfo)
            that.loading = false
            that.$message.success('创建报修单成功')
            that.$router.go(-1)
          } else {
            that.loading = false
            that.$message.error(res.data.message)
          }
        }).catch(() => {
          that.loading = false
          that.$message.error('提交失败')
        })
      },

      handleRemove (file, fileList) {
        this.uploader = fileList
        this.hideUpload = fileList.length > 2;
      },
      handlePictureCardPreview (file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleChange(file, fileList){
        this.uploader = fileList
        this.hideUpload = fileList.length > 2;
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 40% 57px 40%;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .register-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
    height: 40px;
    padding: 0;
  }

  /deep/ .el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #BD1A2D;
    color: #BD1A2D;
  }
</style>

<style>
  .hide .el-upload--picture-card {
    display: none;
  }
</style>

